import LeftNavbar from '../components/LeftNavbar'
import EntityBasicInfo from '../components/EntityBasicInfo'
import EntityEvents from '../components/EntityEvents'
import EntityHome from '../components/EntityHome'
import httpManager from '../../util/common'
import {entityOaid, reportYear} from '../../util/util'

let entity = {
  // router,
  data () {
    return {
      oaid: null,
      title_top_path: '',
      title_top: this.$t('company_home_menu.menu_overview'),
      entity_dict: {
        'official_name': '',
        'official_name_en': '',
        'ticker': ''
      },
      entity_info: null,
      ticker: '',
      bond: false
    }
  },
  components: {
    LeftNavbar, EntityBasicInfo, EntityEvents, EntityHome
  },
  mounted () {
    this.changeOaid()
    this.getEntityBasicInfo(this.oaid)
  },
  methods: {
    changeOaid () {
      this.oaid = this.$route.params.oaid
      this.title_top_path = '/entity/' + this.oaid + '/home'
    },
    getEntityBasicInfo (oaid) {
      let self = this
      entityOaid.oaid(oaid).then(result => {
        oaid =result
      }).then(() => {
        let params = new Map()
        params.set('oaid', oaid)
        httpManager('entity_basic_info', params)
          .then(response => {
            // 获得ticker，判断是否为上市公司
            self.ticker = response.data.data['ticker']
            sessionStorage.setItem("ticker", self.ticker)
            self.bond = response.data.data['bond']
          })
          .catch(error => {
            console.log(error)
          })
      })

    },
  },
  computed: {
    left_nav_list() {
      var list = [
        {label: this.$t('company_home_menu.menu_ESG'), subs: [
          {path: '/entity/' + this.oaid + '/esg/rating', label: this.$t('company_home_menu.menu_ESG_rating')},
          {path: '/entity/' + this.oaid + '/esg/indicator/month', label: this.$t('company_home_menu.menu_ESG_indicator_month')},
          {path: '/entity/' + this.oaid + '/esg/indicator/annual', label: this.$t('company_home_menu.menu_ESG_indicator_annual')},
          {path: '/entity/' + this.oaid + '/esg/bondissuer/indicator/annual', label: this.$t('company_home_menu.menu_ESG_indicator_annual_bond')},
          {path: '/entity/' + this.oaid + '/esg/report/download', label: this.$t('esg.company_esg_report')},
          {path: '/entity/' + this.oaid + '/esg/news', label: this.$t('topNavBar.ESGPublicSentiment')}
        ]},
        {label: this.$t('company_home_menu.menu_sc'), subs: [
          // {path: '#',/* '/entity/' + this.oaid + '/scevent', */label: '供应链事件'},
          {path: '/entity/' + this.oaid + '/scmapping', label: this.$t('company_home_menu.menu_sc_map')},
          {path: '/entity/' + this.oaid + '/suppliers', label: this.$t('company_home_menu.menu_sc_supplier')},
          {path: '/entity/' + this.oaid + '/customers', label: this.$t('company_home_menu.menu_sc_customer')},
          {path: '/entity/' + this.oaid + '/scinfluence', label: this.$t('company_home_menu.menu_sc_influence')},
          {path: '/entity/' + this.oaid + '/scarea',  label: this.$t('company_home_menu.menu_sc_geo')},
        ]},
        // {label: '股权', subs: [{path: '#', label: '股权关系'}]},
        {label: this.$t('company_home_menu.menu_patent'), subs: [{path: '/entity/' + this.oaid + '/patent/detail', label: this.$t('company_home_menu.menu_patent_holding')}]},
        // {label: this.$t('company_home_menu.menu_pollutant'), subs: [
        //   {path: '/entity/' + this.oaid + '/license/detail', label: this.$t('company_home_menu.menu_pollutant_license')},
        //   {path: '/entity/' + this.oaid + '/pollutant/emission', label: this.$t('company_home_menu.menu_pollutant_discharge')}
        // ]},
        {label: this.$t('company_home_menu.menu_carbon'), subs: [
          {path: '/entity/' + this.oaid + '/carbon/carbondata', label: this.$t('company_home_menu.menu_carbon_emission')},
        ]
        },
        // 券商研报信息
        {
          label:this.$t('company_home_menu.menu_report'),subs:[
            {path:'/entity/'+this.oaid+'/report/recent',label:this.$t('company_home_menu.menu_report_latest')}
          ]
        },
        // 产业链
        {
          label:this.$t('topNavBar.industry_chain'),subs:[
            {path:'/entity/'+this.oaid+'/revenue/breakdown',label:this.$t('supplychain.revenue_disassembly')}
          ]
        }
      ]
      if(this.bond && !this.ticker) {
        list[0].subs = [
          {path: '/entity/' + this.oaid + '/esg/bondissuer/indicator/annual', label: this.$t('company_home_menu.menu_ESG_indicator_annual_bond')},
          {path: '/entity/' + this.oaid + '/esg/report/download', label: this.$t('esg.company_esg_report')},
          {path: '/entity/' + this.oaid + '/esg/news', label: this.$t('topNavBar.ESGPublicSentiment')}
        ]
        // 若不为上市公司，则不显示近期研报
        list.splice(4, 1)
      } else if(!this.bond && this.ticker) {
        list[0].subs = [
          {path: '/entity/' + this.oaid + '/esg/rating', label: this.$t('company_home_menu.menu_ESG_rating')},
          {path: '/entity/' + this.oaid + '/esg/indicator/month', label: this.$t('company_home_menu.menu_ESG_indicator_month')},
          {path: '/entity/' + this.oaid + '/esg/indicator/annual', label: this.$t('company_home_menu.menu_ESG_indicator_annual')},
          {path: '/entity/' + this.oaid + '/esg/report/download', label: this.$t('esg.company_esg_report')},
          {path: '/entity/' + this.oaid + '/esg/news', label: this.$t('topNavBar.ESGPublicSentiment')}
        ]
      } else if(!this.bond && !this.ticker) {
        list[0].subs = [
          {path: '/entity/' + this.oaid + '/esg/privateentity/indicator', label: this.$t('company_home_menu.menu_ESG_indicator_annual_nonpub')},
          {path: '/entity/' + this.oaid + '/esg/report/download', label: this.$t('esg.company_esg_report')},
          {path: '/entity/' + this.oaid + '/esg/news', label: this.$t('topNavBar.ESGPublicSentiment')}
        ]
        list.splice(4, 1)
      }

      return list
    }
  }
}

export default entity



// WEBPACK FOOTER //
// ./src/entity/js/entity.js